import { render, staticRenderFns } from "./DiscoveryPositionsDefault.vue?vue&type=template&id=685f1f2d&"
import script from "./DiscoveryPositionsDefault.vue?vue&type=script&lang=js&"
export * from "./DiscoveryPositionsDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports